import React, { useMemo } from "react";
import { getAccuratePixels } from "../../utils/global";

function Rj45({ isDownloadMode, downloadAs }) {
  const totalWidth = isDownloadMode ? 283 + "px" : getAccuratePixels(283);
  const totalHeight = isDownloadMode ? 596 + "px" : getAccuratePixels(596);
  const width = isDownloadMode ? 183 + "px" : getAccuratePixels(183);
  const height = isDownloadMode ? 189 + "px" : getAccuratePixels(189);

  const marginTop = isDownloadMode ? 283 + "px" : getAccuratePixels(283);
  const marginLeft = isDownloadMode ? 50 + "px" : getAccuratePixels(50);

  const border = useMemo(() => {
    if (downloadAs == "cutout-png") {
      return "1px solid black";
    }

    if (downloadAs == "icon-png") {
      return null;
    }

    return "2px solid #6495ED";
  }, [downloadAs]);

  return (
    <div
      style={{
        width: totalWidth,
        height: totalHeight,
        display: "flex",
        flexDirection: "column",
        // justifyContent: "end",
        alignItems: "center",
      }}
    >
      <div
        style={{
          marginBlockStart: marginTop,
          // marginInlineStart: marginLeft,
          width: width,
          height: height,
          border: border,
        }}
      ></div>
    </div>
  );
}

export default Rj45;
